var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{staticClass:"list-box"},[_c('div',{staticClass:"componentclose",on:{"click":function($event){_vm.isShow = false}}},[_vm._v("X")]),_c('companyOchart',{ref:"companyOchart",attrs:{"height":"100%"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }